var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.blueviolet ? 'text-blueviolet' : 'text-white', _vm.className, 'VBANK-logo text-uppercase']},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("v")]),_c('span',{staticClass:"font-weight-light"},[_vm._v("bank")])])}
var staticRenderFns = []

export { render, staticRenderFns }